// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"71df472e","150":"eb6b18d5","186":"69556375","384":"71df472e","437":"eb6b18d5","840":"71df472e"}[chunkId] + ".chunk.css";
};